<div class="d-flex flex-column" *transloco="let t">
  @if (!switchViewSidebarTabStore.loading() && noCustomersAvailable()) {
      <cw-banner
        class="mt-m"
        type="info"
        [description]="t('No offline customers available.')"
        [enableClose]="false"
      />
  }
  <app-country-customer-selection
    [countryControl]="countryControl"
    [customerControl]="customerControl"
    [disableCustomerInput]="noCustomersAvailable()"
    [filteredCustomers]="switchViewSidebarTabStore.getFilteredCustomers()"
    [selectedCustomer]="this.switchViewSidebarTabStore.selectedCustomer()"
  />
  <app-sidebar-heartbeat [isLoading]="switchViewSidebarTabStore.loading()"/>
</div>
